// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Hero from './components/sections/Hero';
import Features from './components/sections/Features';
import Tutorial from './components/sections/Tutorial';
import About from './components/sections/About';
import Pricing from './components/sections/Pricing';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import TermsOfService from './components/legal/TermsOfService';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import SoftwareLicenseAgreement from './components/legal/SoftwareLicenseAgreement';
import RefundPolicy from './components/legal/RefundPolicy';
import GetStarted from './components/pages/GetStarted';
import ManageSubscription from './components/pages/ManageSubscription';
import ComingSoon from './components/pages/ComingSoon';
import SponsorInfo from './components/pages/SponsorInfo';
import SponsorSubmit from './components/pages/SponsorSubmit';
import SponsorPortal from './components/pages/SponsorPortal';
import './styles/core.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={
            <>
              <Navbar />
              <main>
                <Hero />
                <Tutorial />
                <Features />
                <About />
                <Pricing />
                <Contact />
              </main>
              <Footer />
            </>
          } />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/software-license-agreement" element={<SoftwareLicenseAgreement />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/manage-subscription" element={<ManageSubscription />} />
          <Route path="/sponsor" element={<SponsorInfo />} />
          <Route path="/sponsor/apply" element={<SponsorSubmit />} />
          <Route path="/sponsor/portal" element={<SponsorPortal />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
